import { FC } from "react";
import { Theme, MessagesType } from "../../../types";
import { MenuProps } from "../../types";
import { megaMenuWidgetColumn } from "../../styles";
import clsx from "clsx";
import SearchMarketWidget from "./SearchMarketWidget";
import LeaderboardWidget from "./LeaderboardWidget";
import BotProductsWidget from "./BotProductsWidget";

type WidgetType = "searchMarket" | "leaderboard" | "botProducts";

interface MegaMenuWidgetSlotProps {
  widgetType: WidgetType;
  theme: Theme;
  /** 所属一级菜单 label，如 "spot"、"futures"，用于确定 widget 上下文 */
  menuLabel?: MessagesType | "";
  /** 当前 hover 的 isPrimary 项，用于传递上下文给 widget */
  hoveredItem?: MenuProps | null;
}

/**
 * 二级展开菜单 - Widget 插槽
 *
 * 根据 widgetType 渲染对应的 widget 组件：
 * - "searchMarket"：搜索行情面板（SearchBox + 行情列表）
 * - "leaderboard"：榜单面板（Top ROI 列表 + CTA）
 * - "botProducts"：Bot 产品列表（Futures/Spot Tab + 产品列表）
 */
const MegaMenuWidgetSlot: FC<MegaMenuWidgetSlotProps> = ({
  widgetType,
  theme,
  menuLabel,
  hoveredItem
}) => {
  return (
    <div className={clsx(megaMenuWidgetColumn({ mode: theme }), "h-full")}>
      {widgetType === "searchMarket" && (
        <SearchMarketWidget theme={theme} menuLabel={menuLabel} hoveredItem={hoveredItem} />
      )}
      {widgetType === "leaderboard" && (
        <LeaderboardWidget theme={theme} hoveredItem={hoveredItem} />
      )}
      {widgetType === "botProducts" && (
        <BotProductsWidget theme={theme} defaultTab={menuLabel === "spot" ? "spot" : "futures"} />
      )}
    </div>
  );
};

export default MegaMenuWidgetSlot;
